module.exports = __webpack_public_path__ + "school/img/trainBg2.3881e77a.jpg";